// Widget registry: tool name → how its block renders and exports.
//
//   kind: 'display'  — renders the tool input; local, throwaway UI state
//         'input'    — the answer ends here; the user's choice is the next question
//         'stateful' — user edits saved per conversation (widget_state)
//
// Schemas live in shared/widgets.js (buildAnswer drops finished input that
// fails them); text export lives in text.js.

import { WIDGET_TEXT } from './text.js'
import { Checklist } from './Checklist.jsx'
import { Clarify } from './Clarify.jsx'
import { EmailDraft } from './EmailDraft.jsx'
import { Gotchas } from './Gotchas.jsx'
import { Handoff } from './Handoff.jsx'
import { MappingGrid } from './MappingGrid.jsx'
import { PipeFlow } from './PipeFlow.jsx'
import { Questionnaire } from './Questionnaire.jsx'
import { RequestBuilder } from './RequestBuilder.jsx'
import { ScopePicker } from './ScopePicker.jsx'

const entry = (Component, kind, name) => ({ Component, kind, toText: WIDGET_TEXT[name] })

export const WIDGETS = {
  show_pipe_flow: entry(PipeFlow, 'display', 'show_pipe_flow'),
  show_handoff: entry(Handoff, 'display', 'show_handoff'),
  show_endpoint: entry(RequestBuilder, 'display', 'show_endpoint'),
  show_fields: entry(MappingGrid, 'display', 'show_fields'),
  show_gotchas: entry(Gotchas, 'display', 'show_gotchas'),
  pick_scope: entry(ScopePicker, 'input', 'pick_scope'),
  show_questionnaire: entry(Questionnaire, 'display', 'show_questionnaire'),
  show_checklist: entry(Checklist, 'display', 'show_checklist'),
  show_email_draft: entry(EmailDraft, 'stateful', 'show_email_draft'),
  ask_clarification: entry(Clarify, 'input', 'ask_clarification'),
}

export { WidgetContext, useWidgetContext } from './context.js'
export { WidgetBoundary } from './primitives.jsx'
